import { delay, put, takeEvery } from "redux-saga/effects";

import {
  getlaunchIframeStart,
  getlaunchIframeSuccess,
  getlaunchIframeFailure
} from "../../redux/sportsIframe";
import {
  navigateTarget,
  showErrorMessage
} from "../../../redux-saga/redux/toast";
import sportsIframeService from "../../services/sportsIframe";

function* sportsIframeWatcher() {
  yield takeEvery(getlaunchIframeStart.type, sportsIframeWorker);
}

function* sportsIframeWorker(action) {
  try {
    const { url, error, errorMsg } = yield sportsIframeService.getLaunchIframe(
      action.payload
    );

    if (url) {
      const operatorToken = url.split("operatorToken=")[1];

      yield put(getlaunchIframeSuccess(url));
      document.cookie = `operatorToken=${operatorToken}; path=/; secure; samesite=strict; max-age=86400`;
    }
    if (error || errorMsg) {
      yield put(showErrorMessage({ msg: error || errorMsg }));
      yield put(getlaunchIframeFailure(errorMsg));
      yield delay(1000);
      yield put(navigateTarget(-1));
    }
  } catch (error) {
    yield put(getlaunchIframeFailure());
    yield put(showErrorMessage({ msg: error }));
  }
}

export default sportsIframeWatcher;
